package com.solevo.dist.pages.orderdetails

import kotlinx.serialization.Serializable

@Serializable
data class InvoicePayload(
    val transactionId: String,
    val invoiceId: String,
    val transactionType: String,
)


